import React from "react";

const MainFooter = () => {
  return (
    <footer style={styles.footer}>
      <div style={styles.container}>
        <span style={styles.poweredBy}>
          Powered by
          <img src={"../../logo.jpg"} alt="Company Logo" style={styles.logo} />
        </span>
      </div>
    </footer>
  );
};

const styles = {
  footer: {
    color: "#fff",
    padding: "1rem 2rem",
    textAlign: "center",
    marginBottom: "3rem",
  },
  container: {
    maxWidth: "1200px",
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  poweredBy: {
    fontSize: "1.2rem",
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
  },
  logo: {
    width: "30px",
    height: "30px",
    borderRadius: "15px",
  },
  redirectInfo: {
    marginTop: "1rem",
    fontSize: "1rem",
  },
  link: {
    color: "#4CAF50",
    marginLeft: "0.5rem",
    textDecoration: "none",
  },
};

export default MainFooter;
